import mockdata from '../mockdata'

export const CLEAR = 'ui-settings/credentials/CLEAR'
export const LOAD = 'ui-settings/credentials/LOAD'
export const SET = 'ui-settings/credentials/SET'

export const defaultState = {
  list: [],
  fetched: false,
  fetching: false,
  count: 0,
  total: 0,
  pages: 0
}

export default function reducer (state = defaultState, action = {}) {
  switch (action.type) {
    case CLEAR:
      return {
        ...defaultState
      }

    case LOAD:
      return {
        ...state,
        fetched: false,
        fetching: true
      }

    case SET:
      return {
        ...state,
        fetched: true,
        fetching: false,
        list: action.payload,
        count: action.payload.length,
        total: action.payload.length,
        pages: 1
      }

    default:
      return state
  }
}

export function clearCredentials () {
  return {
    type: CLEAR
  }
}

export function resetCredentials () {
  return dispatch => {
    dispatch(clearCredentials())
    return dispatch(loadCredentials())
  }
}

export function loadCredentials () {
  return (dispatch, getState, api) => {
    dispatch({ type: LOAD })

    return api
      .credentials
      .get()
      .then(payload => {
        dispatch({ type: SET, payload })
      })
      .catch(err => {
        console.error(`Error fetching credentials: ${err.message}`)
        dispatch(clearCredentials())
      })
  }
}



// WEBPACK FOOTER //
// ./ducks/credentials.js